import React, { ReactNode, useContext } from "react";
import { Panel, SectionHeader } from "common/NewLook";
import { NewLookPortfolioContext } from "features/portfolio/NewLook/NewLookPortfolio.context.ts";
import NewLookOverview from "features/portfolio/NewLook/NewLookOverview.tsx";
import {
  NewLookPageBody,
  NewLookPanelTable,
} from "features/portfolio/NewLook/styles.ts";

interface NewLookPortfolioLayoutProps {
  chart: ReactNode;
  /** A bare allocation card; its title is drawn by the overview panel. */
  allocation: ReactNode;
  allocationTitle: ReactNode;
  title: ReactNode;
  count?: number;
  content: ReactNode;
  /** Cards render straight on the canvas; tables sit in a panel. */
  isCards?: boolean;
  /** False with nothing to chart, so the empty state leads. */
  showOverview?: boolean;
}

/** Shared new-look layout of the assets and positions pages. */
const NewLookPortfolioLayout = ({
  chart,
  allocation,
  allocationTitle,
  title,
  count,
  content,
  isCards,
  showOverview = true,
}: NewLookPortfolioLayoutProps) => {
  const { listActions } = useContext(NewLookPortfolioContext) || {};
  return (
    <NewLookPageBody>
      {showOverview && (
        <NewLookOverview
          allocationTitle={allocationTitle}
          allocation={allocation}
          chart={chart}
        />
      )}
      {isCards ? (
        <section>
          <SectionHeader title={title} count={count} actions={listActions} />
          {content}
        </section>
      ) : (
        <Panel title={title} count={count} actions={listActions} flush={true}>
          <NewLookPanelTable>{content}</NewLookPanelTable>
        </Panel>
      )}
    </NewLookPageBody>
  );
};

export default NewLookPortfolioLayout;
